module.exports = __webpack_public_path__ + "static/arts_academy-42aa092a8309b50b8c95d5e71843fa05.png";